import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_InfractionMaintenanceSBT } from "../shared/data.service";

import {
	wsInfractionMaintenanceInfractionGetDataParm,
	wsInfractionMaintenanceInfractionSampleInfo,
	wsStudentFairAccessCriteriaInfo,
} from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionGetDataInfo } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionGroupInfo } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionLevelInfo } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionAssignedPenaltyInfo } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionPenaltyInfo } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";

import { wsInfractionMaintenanceInfractionAddParm } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionUpdateParm } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";
import { wsInfractionMaintenanceInfractionPenalityParm } from "../shared/wsInfractionMaintenanceInfractionModifyInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { ViewChild } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./addeditinfractionsbt.component.html",
	styleUrls: ["./addeditinfractionsbt.component.css"],
	providers: [ConfirmationService],
})
export class AddEditInfractionSBTComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_InfractionMaintenanceSBT,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.InfractionID = this.dialogConfig.data.InfractionID;
		this.isAdd = this.dialogConfig.data.isAdd;

		let parm: wsInfractionMaintenanceInfractionGetDataParm = {
			UserID: this.UserID,
			SchoolID: this.SchoolID,
			InfractionID: this.InfractionID,
		};

		this.isBusy = true;
		this.dataService.InfractionMaintenanceInfractionDataGet(parm).subscribe((data) => this.InfractionMaintenanceInfractionDataGet_Complete(data));
	}

	ngOnDestroy() {}

	///////////////////////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////////////////////

	@ViewChild("dtAssigned") dtAssigned: Table;
	@ViewChild("dtActions") dtActions: Table;
	@ViewChild("filterSchoolsDesc", { static: false })
	public filterSchoolsDesc: Dropdown;
	@ViewChild("filterDefinedByDesc", { static: false })
	public filterDefinedByDesc: Dropdown;

	public isBusy: boolean = false;
	public isShowInfo1: boolean = false;
	public isShowInfo2: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public SchoolID: number = -1;
	public InfractionID: number = -1;
	public isAdd: boolean = false;
	public isViewOnly: boolean = false;
	public isLimitedEdit: boolean = false;
	public SelectedGroupValue: string = "2";

	public InfractionData: wsInfractionMaintenanceInfractionGetDataInfo;

	public lstInfractionGroupItems: wsInfractionMaintenanceInfractionGroupInfo[] = [];
	public SelectedInfractionGroup: wsInfractionMaintenanceInfractionGroupInfo;

	public lstInfractionLevelItems: wsInfractionMaintenanceInfractionLevelInfo[] = [];
	public SelectedInfractionLevel: wsInfractionMaintenanceInfractionLevelInfo;

	public lstInfractionPenaltyItems: wsInfractionMaintenanceInfractionAssignedPenaltyInfo[] = [];
	public SelectedInfractionPenalty: wsInfractionMaintenanceInfractionAssignedPenaltyInfo;

	public lstPenaltyItems: wsInfractionMaintenanceInfractionPenaltyInfo[] = [];
	public SelectedPenalty: wsInfractionMaintenanceInfractionPenaltyInfo;

	public rInfractionCD: string = "";
	public rInfractionDesc: string = "";
	public rIsWeaponType: boolean = false;
	public rIsEDCRAssignable: boolean = false;

	//	Filters
	public lstSchoolsDescs: any = [];
	public lstDefinedByDescs: any = [];

	//	DataTable page counts
	public pagefirst1: number = 0;
	public pagerows1: number = 5;

	public pagefirst2: number = 0;
	public pagerows2: number = 5;

	public ErrorMessage: string = "";

	//
	// SBM
	//

	public lstWorkflowTypeDesc: string[] = [];
	public lstAllowPartialDesc: string[] = [];

	public isShowInfo3: boolean = false;
	public pagefirst3: number = 0;
	public pagerows3: number = 5;

	public isShowInfo4: boolean = false;
	public pagefirst4: number = 0;
	public pagerows4: number = 5;

	public isShowInfo5: boolean = false;
	public pagefirst5: number = 0;
	public pagerows5: number = 5;

	public isShowInfo6: boolean = false;
	public pagefirst6: number = 0;
	public pagerows6: number = 5;

	public rOutOfSchoolAllowed: boolean = false;
	public rStudentFairAccess: boolean = false;
	public rEmailCareTeam: boolean = false;
	public rIsBullying: boolean = false;
	public rEmotionalDistress: boolean = false;
	public rBodilyInjury: boolean = false;

	public lstAssignedInfractionSample: any = [];
	public SelectedAssignedInfractionSample: any;

	public lstUnassignedInfractionSample: any = [];
	public SelectedUnassignedInfractionSample: any;

	public lstAssignedStudentFairAccessCriteria: any = [];
	public SelectedAssignedStudentFairAccess: any;

	public lstUnassignedStudentFairAccessCriteria: any = [];
	public SelectedUnassignedStudentFairAccess: any;

	///////////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////////////////////////////////
	InfractionMaintenanceInfractionDataGet_Complete(data: any) {
		this.InfractionData = data;

		this.lstInfractionGroupItems = this.InfractionData.InfractionGroupItems;
		this.lstInfractionLevelItems = this.InfractionData.InfractionLevelItems;
		this.lstInfractionPenaltyItems = this.InfractionData.InfractionPenaltyItems;
		this.lstPenaltyItems = this.InfractionData.PenaltyItems;

		this.rInfractionCD = this.InfractionData.InfractionCD;
		this.rInfractionDesc = this.InfractionData.InfractionDesc;
		this.rIsWeaponType = this.InfractionData.IsWeaponType;
		this.rIsEDCRAssignable = this.InfractionData.IsEDCRAssignable;

		//
		// SBM
		//
		this.rOutOfSchoolAllowed = this.InfractionData.OutOfSchoolAllowed;
		this.rStudentFairAccess = this.InfractionData.StudentFairAccess;
		this.rEmailCareTeam = this.InfractionData.EmailCareTeam;
		this.rIsBullying = this.InfractionData.IsBullying;
		this.rEmotionalDistress = this.InfractionData.EmotionalDistress;
		this.rBodilyInjury = this.InfractionData.BodilyInjury;
		this.lstAssignedInfractionSample = this.InfractionData.lstAssignedInfractionSample;
		this.lstUnassignedInfractionSample = this.InfractionData.lstUnassignedInfractionSample;
		this.lstAssignedStudentFairAccessCriteria = this.InfractionData.lstAssignedStudentFairAccessCriteria;
		this.lstUnassignedStudentFairAccessCriteria = this.InfractionData.lstUnassignedStudentFairAccessCriteria;

		let tmpDefinedByID = this.InfractionData.DefinedByID;

		if (this.isAdd == true) {
			//
			//	Add Mode
			//
			this.SelectedGroupValue = "2"; // Current School Only (Default)
			this.isViewOnly = false;
			this.isLimitedEdit = false;
		} else {
			//
			//	Edit Mode
			//
			this.isViewOnly = false;
			this.isLimitedEdit = false;

			if (this.InfractionData.SchoolID < 1) {
				//
				// All Schools
				//
				this.SelectedGroupValue = "1"; // All Schools

				if (this.InfractionData.DefinedByID == 1 || this.InfractionData.DefinedByID == 2) {
					// System or Import
					if (this.UserLevelID == 1) {
						// District Level
						this.isLimitedEdit = true;
					} else {
						this.isViewOnly = true;
					}
				}

				if (this.InfractionData.DefinedByID == 3 || this.InfractionData.DefinedByID == 4) {
					// School or District
					if (this.UserLevelID == 3) {
						// School Level
						this.isViewOnly = true;
					}
				}
			} else {
				//
				//	Current School Only
				//
				this.SelectedGroupValue = "2"; // Current School Only

				if (this.InfractionData.DefinedByID == 1 || this.InfractionData.DefinedByID == 2) {
					// System or Import
					if (this.UserLevelID == 1) {
						// District Level
						this.isLimitedEdit = true;
					} else {
						this.isViewOnly = true;
					}
				}

				if (this.InfractionData.DefinedByID == 4) {
					// District
					if (this.UserLevelID == 3) {
						// School Level
						this.isViewOnly = true;
					}
				}
			}
		}

		//
		//	Select Default InfractionGroup
		//
		this.SelectedInfractionGroup = this.lstInfractionGroupItems[0];

		this.lstInfractionGroupItems.forEach((item) => {
			if (item.InfractionGroupID == this.InfractionData.InfractionGroupID) {
				this.SelectedInfractionGroup = item;
			}
		});

		//
		//	Select Default InfractionLevel
		//
		this.SelectedInfractionLevel = this.lstInfractionLevelItems[0];

		this.lstInfractionLevelItems.forEach((item) => {
			if (item.InfractionLevelID == this.InfractionData.InfractionLevelID) {
				this.SelectedInfractionLevel = item;
			}
		});

		//
		//	Set Filter Lists
		//
		this.lstSchoolsDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.SchoolsDesc)));
		this.lstDefinedByDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.DefinedByDesc)));
		this.lstWorkflowTypeDesc = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.WorkflowTypeDesc)));
		this.lstAllowPartialDesc = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.AllowPartialDesc)));

		//
		//	Set Filter Defaults
		//
		this.onSetFilterDefaults();

		//
		//	Reset Sort
		//
		this.dtAssigned.multiSortMeta = [];
		this.dtAssigned.multiSortMeta.push({ field: "PenaltyDesc", order: 1 });
		this.dtAssigned.sortMultiple();

		this.dtActions.multiSortMeta = [];
		this.dtActions.multiSortMeta.push({ field: "PenaltyDesc", order: 1 });
		this.dtActions.sortMultiple();

		this.isBusy = false;
	}
	///////////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////////////////////////////////

	onToggleInfo1() {
		this.isShowInfo1 = !this.isShowInfo1;
	}

	onToggleInfo2() {
		this.isShowInfo2 = !this.isShowInfo2;
	}

	onToggleInfo3() {
		this.isShowInfo3 = !this.isShowInfo3;
	}

	onToggleInfo4() {
		this.isShowInfo4 = !this.isShowInfo4;
	}

	onToggleInfo5() {
		this.isShowInfo5 = !this.isShowInfo5;
	}

	onToggleInfo6() {
		this.isShowInfo6 = !this.isShowInfo6;
	}

	onRemove() {
		this.ErrorMessage = "";

		if (this.SelectedInfractionPenalty == null) {
			this.ErrorMessage = "Please select an assigned action to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstInfractionPenaltyItems = this.lstInfractionPenaltyItems.filter((obj) => obj != this.SelectedInfractionPenalty);
		this.SelectedInfractionPenalty = null;
	}

	onAssign() {
		this.ErrorMessage = "";

		if (this.SelectedPenalty == null) {
			this.ErrorMessage = "Please select an action to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstInfractionPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.SelectedPenalty.PenaltyID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This action has already been assigned.";
			return;
		}

		let rPen: wsInfractionMaintenanceInfractionAssignedPenaltyInfo = {
			PenaltyID: this.SelectedPenalty.PenaltyID,
			isPrimary: false,
			PenaltyCD: this.SelectedPenalty.PenaltyCD,
			PenaltyDesc: this.SelectedPenalty.PenaltyDesc,
			Message: this.SelectedPenalty.Message,
			FontColor: this.SelectedPenalty.FontColor,
			DefinedByID: this.SelectedPenalty.DefinedByID,
			DefinedByDesc: this.SelectedPenalty.DefinedByDesc,
			SchoolID: this.SelectedPenalty.SchoolID,
			SchoolsDesc: this.SelectedPenalty.SchoolsDesc,
			WorkflowTypeID: this.SelectedPenalty.WorkflowTypeID,
			WorkflowTypeDesc: this.SelectedPenalty.WorkflowTypeDesc,
			AllowPartial: this.SelectedPenalty.AllowPartial,
			AllowPartialDesc: this.SelectedPenalty.AllowPartialDesc,
		};

		this.lstInfractionPenaltyItems = [...this.lstInfractionPenaltyItems, rPen];
		this.SelectedPenalty = null;
	}

	onRemoveSample() {
		this.ErrorMessage = "";

		if (this.SelectedAssignedInfractionSample == null) {
			this.ErrorMessage = "Please select an assigned infraction sample to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstAssignedInfractionSample = this.lstAssignedInfractionSample.filter((obj) => obj != this.SelectedAssignedInfractionSample);
		this.SelectedAssignedInfractionSample = null;
	}

	onAssignSample() {
		this.ErrorMessage = "";

		if (this.SelectedUnassignedInfractionSample == null) {
			this.ErrorMessage = "Please select an infraction sample to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstAssignedInfractionSample.forEach((item) => {
			if (item.InfractionSampleID == this.SelectedUnassignedInfractionSample.InfractionSampleID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This infraction sample has already been assigned.";
			return;
		}

		let rInfSam: wsInfractionMaintenanceInfractionSampleInfo = {
			InfractionSampleID: this.SelectedUnassignedInfractionSample.InfractionSampleID,
			InfractionSampleDesc: this.SelectedUnassignedInfractionSample.InfractionSampleDesc,
			SchoolID: this.SelectedUnassignedInfractionSample.SchoolID,
			SchoolsDesc: this.SelectedUnassignedInfractionSample.SchoolsDesc,
		};

		this.lstAssignedInfractionSample = [...this.lstAssignedInfractionSample, rInfSam];
		this.SelectedUnassignedInfractionSample = null;
	}

	onRemoveSFA() {
		this.ErrorMessage = "";

		if (this.SelectedAssignedStudentFairAccess == null) {
			this.ErrorMessage = "Please select an assigned student fair access criteria to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstAssignedStudentFairAccessCriteria = this.lstAssignedStudentFairAccessCriteria.filter((obj) => obj != this.SelectedAssignedStudentFairAccess);
		this.SelectedAssignedStudentFairAccess = null;
	}

	onAssignSFA() {
		this.ErrorMessage = "";

		if (this.SelectedUnassignedStudentFairAccess == null) {
			this.ErrorMessage = "Please select a student fair access criteria to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstAssignedStudentFairAccessCriteria.forEach((item) => {
			if (item.StudentFairAccessCriteriaID == this.SelectedUnassignedStudentFairAccess.StudentFairAccessCriteriaID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This student fair access criteria has already been assigned.";
			return;
		}

		let rSFA: wsStudentFairAccessCriteriaInfo = {
			StudentFairAccessCriteriaID: this.SelectedUnassignedStudentFairAccess.StudentFairAccessCriteriaID,
			StudentFairAccessCriteriaDesc: this.SelectedUnassignedStudentFairAccess.StudentFairAccessCriteriaDesc,
			SchoolID: this.SelectedUnassignedStudentFairAccess.SchoolID,
			SchoolsDesc: this.SelectedUnassignedStudentFairAccess.SchoolsDesc,
		};

		this.lstAssignedStudentFairAccessCriteria = [...this.lstAssignedStudentFairAccessCriteria, rSFA];
		this.SelectedUnassignedStudentFairAccess = null;
	}

	onAddUpdate() {
		this.ErrorMessage = "";

		//
		// Validate
		//
		if (this.rInfractionCD.length < 1) {
			this.ErrorMessage = "Code must be entered.";
			return;
		}

		if (this.rInfractionDesc.length < 1) {
			this.ErrorMessage = "Description must be entered.";
			return;
		}

		//
		// Make sure a default Action has been set if an action has been assigned
		//
		let isPrimarySet: Boolean = false;

		if (this.lstInfractionPenaltyItems.length > 0) {
			this.lstInfractionPenaltyItems.forEach((item) => {
				if (item.isPrimary == true) {
					isPrimarySet = true;
				}
			});
		} else {
			isPrimarySet = true;
		}

		if (isPrimarySet == false) {
			this.ErrorMessage = "A default action must be selected.";
			return;
		}

		//
		//	Validations Passed, Do the Insert or Update
		//
		if (this.InfractionID < 1) {
			//
			//	INSERT
			//
			let parmSchoolID: number;

			if (this.SelectedGroupValue == "1") {
				// All Schools
				parmSchoolID = -1;
			} else {
				parmSchoolID = this.SchoolID; // current school
			}

			let lstPenaltyItems: wsInfractionMaintenanceInfractionPenalityParm[] = [];

			this.lstInfractionPenaltyItems.forEach((item) => {
				lstPenaltyItems.push({
					PenaltyID: item.PenaltyID,
					isPrimary: item.isPrimary,
				});
			});

			//
			// SBM
			//

			let parm: wsInfractionMaintenanceInfractionAddParm = {
				InfractionCD: this.rInfractionCD,
				InfractionDesc: this.rInfractionDesc,
				InfractionGroupID: this.SelectedInfractionGroup.InfractionGroupID,
				InfractionLevelID: this.SelectedInfractionLevel.InfractionLevelID,
				IsWeaponType: this.rIsWeaponType,
				IsEDCRAssignable: this.rIsEDCRAssignable,
				SchoolID: parmSchoolID,

				//
				// SBM Bool
				//
				OutOfSchoolAllowed: this.rOutOfSchoolAllowed,
				StudentFairAccess: this.rStudentFairAccess,
				EmailCareTeam: this.rEmailCareTeam,
				IsBullying: this.rIsBullying,
				EmotionalDistress: this.rEmotionalDistress,
				BodilyInjury: this.rBodilyInjury,

				InfractionPenaltyItems: lstPenaltyItems,

				//
				// SBM Lists
				//

				lstInfractionSample: this.lstAssignedInfractionSample,
				lstStudentFairAccess: this.lstAssignedStudentFairAccessCriteria,
			};

			this.isBusy = true;
			this.dataService.InfractionMaintenanceInfractionAdd(parm).subscribe((data) => this.InfractionMaintenanceInfractionAdd_Complete(data));
		} else {
			//
			//	UPDATE
			//
			let lstPenaltyItems: wsInfractionMaintenanceInfractionPenalityParm[] = [];

			this.lstInfractionPenaltyItems.forEach((item) => {
				lstPenaltyItems.push({
					PenaltyID: item.PenaltyID,
					isPrimary: item.isPrimary,
				});
			});

			let parm: wsInfractionMaintenanceInfractionUpdateParm = {
				InfractionID: this.InfractionID,
				InfractionCD: this.rInfractionCD,
				InfractionDesc: this.rInfractionDesc,
				InfractionGroupID: this.SelectedInfractionGroup.InfractionGroupID,
				InfractionLevelID: this.SelectedInfractionLevel.InfractionLevelID,
				IsWeaponType: this.rIsWeaponType,
				IsEDCRAssignable: this.rIsEDCRAssignable,

				//
				// SBM Bool
				//
				OutOfSchoolAllowed: this.rOutOfSchoolAllowed,
				StudentFairAccess: this.rStudentFairAccess,
				EmailCareTeam: this.rEmailCareTeam,
				IsBullying: this.rIsBullying,
				EmotionalDistress: this.rEmotionalDistress,
				BodilyInjury: this.rBodilyInjury,

				InfractionPenaltyItems: lstPenaltyItems,

				//
				// SBM Lists
				//

				lstInfractionSample: this.lstAssignedInfractionSample,
				lstStudentFairAccess: this.lstAssignedStudentFairAccessCriteria,
			};

			this.isBusy = true;
			this.dataService.InfractionMaintenanceInfractionUpdate(parm).subscribe((data) => this.InfractionMaintenanceInfractionUpdate_Complete(data));
		}
	}

	InfractionMaintenanceInfractionAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	InfractionMaintenanceInfractionUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////////////////////////////////

	onSFAOptionChange(e: any) {
		this.rStudentFairAccess = e;

		//
		// Clear Student Fair Access Criteria Data
		//
		if (e == false) {
			this.lstAssignedStudentFairAccessCriteria = [];
			this.SelectedAssignedStudentFairAccess = null;
		}
	}

	onInfractionGroupChange(e: any) {}

	onInfractionLevelChange(e: any) {}

	onRowSelect1(event) {}

	onRowUnselect1(event) {
		//
		//	Need to set SelectedPenalty here. We don't unselect when selected.
		//
		this.SelectedInfractionPenalty = event.data;
	}

	onRowSelect2(event) {}

	onRowUnselect2(event) {
		//
		//	Need to set SelectedPenalty here. We don't unselect when selected.
		//
		this.SelectedPenalty = event.data;
	}

	onRowSelect3(event) {}

	onRowUnselect3(event) {
		this.SelectedAssignedInfractionSample = event.data;
	}

	onRowSelect4(event) {}

	onRowUnselect4(event) {
		this.SelectedUnassignedInfractionSample = event.data;
	}

	onRowSelect5(event) {}

	onRowUnselect5(event) {
		this.SelectedAssignedStudentFairAccess = event.data;
	}

	onRowSelect6(event) {}

	onRowUnselect6(event) {
		this.SelectedUnassignedStudentFairAccess = event.data;
	}

	onHandleSort1(e: any) {}

	onHandleSort2(e: any) {}

	onHandleSort3(e: any) {}

	onHandleSort4(e: any) {}

	onHandleSort5(e: any) {}

	onHandleSort6(e: any) {}

	onChangePrimary(e: any) {
		this.lstInfractionPenaltyItems.forEach((item) => {
			if (e.PenaltyID != item.PenaltyID) {
				item.isPrimary = false;
			}
		});
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////////////////////////////////

	onSetFilterDefaults() {
		this.dtActions.filters.SchoolsDesc["value"] = null; // Default To 'Any'
		this.dtActions.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////////
}
